<script lang="ts">
	import RightCondensed from '@icons/RightCondensed.svelte';
	import Icon from './Icon.svelte';

	export let links: {
		label: string;
		href?: string;
	}[] = [{ href: '/', label: 'Mehr Magenta Events' }, { label: 'Event Name' }];
</script>

<ul
	class="breadcrumbs flex items-center flex-wrap min-h-9 py-[9px] pl-3 mdheader:pl-4 xlheader:px-10"
>
	{#each links as link, i}
		{#if i < links.length - 1}
			<li class="flex gap-1.5 items-center">
				<a href={link.href} class="text-additional hover:underline focus:underline">
					{link.label}
				</a>
				<Icon component={RightCondensed} class="!w-4 !h-4 mr-1.5" aria-hidden="true" />
			</li>
		{:else}
			<li class="font-bold">{link.label}</li>
		{/if}
	{/each}
</ul>

<style>
	.breadcrumbs {
		max-width: var(--content-max-width);
	}
</style>
